import store from '../../store';

export const initializeApp = async (lang) => {
  try {
    await store.dispatch('AuthFirebase/initializeFirebase');

    await Promise.all([
      store.dispatch('Init/fetch')
    ]);

    if (!localStorage.getItem('client_init_ts')) {
      localStorage.setItem('client_init_ts', String(Date.now()));
    }

  } catch (error) {
    console.error('Error in initializeApp:', error);
  }
};
